import React from "react";
import Navbar from "../widgets/Navbar";
import Footer from "../widgets/Footer";

const ReturnPolicy = () => {
  return (
    <div>
      <Navbar />
       <section className="in_page p70 bg4">
        <div className="container">
     <h1 className="hadding">Return Policy</h1> 
          
          
 <h4 className="mb-3"><b>Scope</b></h4>
 <p>This Return Policy applies to Dyntech’s digital products and professional services, including software licenses, platform subscriptions, and advisory engagements.</p>

  <h4 className="mb-3 mt-4 mt-md-5"><b>Non-Refundable Items</b></h4>
 
           
<ul className="list">
   <li><b>Software Licensing & Subscriptions:  </b>  Once activated, non-tangible digital goods (platform access, APIs) are non-refundable.</li> 
   <li><b> One-Time Services: </b>  Project-based fees (e.g., blockchain development sprints) are non-refundable after work commences.</li> 
</ul> 
          
  </div>
      </section>
      <Footer />
    </div>
  );
};

export default ReturnPolicy;
